export default __webpack_public_path__ + "assets/4927a7ec659ede78691df8704fe28c0a.svg";